import CssCenter from "../../../../src/components/css-center";
import * as React from 'react';
export default {
  CssCenter,
  React
};